export default "__VITE_ASSET__$hXIam0q__"